<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-pine-tree">
<h1>The Pine Tree</h1>
<p>There was a huge pine tree near the corner of English and Station Roads before any development in that area. This Pine was ‘our’ tree. Serge Lévesque and I would go to Wood’s store and buy a 5-cent big bottle of Kik Cola.</p>
<p>Then the largest bag of chips from my parents’ store (Moore’s General Store) lay around that old pine tree all day, plotting the upcoming course of our respective lives. We started and completed so many adventures under that old tree.</p>
<p>One could sense the relief of that old tree, as it seemed to sigh when it saw us coming with our supply of <span dir="rtl">”</span>food for thought” for another day travelling via daydreams.</p>
<p>We travelled the world, near and far, under that old tree. We left our youth behind under that old pine tree.</p>
<p>I miss my friend Serge and that old pine tree. Travelling was so much more fun with my friend Serge and that big old pine tree.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?bd765888